module.exports = __webpack_public_path__ + "img/bitget.f4a73370.png";